import React from 'react';

import Typography from '../../library/typography/typography';

import './treadwell-rank-banner.scss';

interface TreadwellRankBannerProps {
  rank?: number;
  topRecommendationText?: string;
}
function TreadwellRankBanner(props: TreadwellRankBannerProps) {
  const { rank, topRecommendationText = 'top recommended' } = props;

  return (
    <div className="treadwell-rank-banner" styleName="container">
      <img alt="Treadwell" src="/images/treadwell_icon.svg" styleName="icon" />
      <div
        className="treadwell-rank-banner__text-container"
        styleName="text-container"
      >
        <Typography size="small" styleName="title">
          #{rank} {rank === 1 ? topRecommendationText : 'recommendation'}
        </Typography>
      </div>
    </div>
  );
}

export default TreadwellRankBanner;
